export default class Discipline {
  disciplineId?: number | null;
  code?: string | null;
  name?: string | null;

  public constructor(params: Discipline = {} as Discipline) {
    let { disciplineId = 0, code = "", name = "" } = params;
    this.disciplineId = disciplineId;
    this.code = code;
    this.name = name;
  }
}
